<template>
  <div class="register">
    <div
      class="register__container"
      :style="{
        width: user && !isMobile ? '650px' : isMobile ? '350px' : '400px',
        marginTop: isMobile ? '50px' : '100px',
      }"
    >
      <div class="register__container__header">
        <div class="register__container__header__icon">
          <svg-icon iconClass="logoShape" className="register__container__header__icon--logo"></svg-icon>
          <svg-icon iconClass="logoText" className="register__container__header__icon--text"></svg-icon>
        </div>
        <div class="register__container__header__text">
          {{ $t('register.title') }}
        </div>
      </div>
      <div class="register__container__form">
        <div class="register__container__form__intro" v-if="code && user">
          <p
            class="register__container__form__intro__text"
            v-html="
              $t('register.intro', {
                used_day_count: user.used_day_count,
                memo_count: user.memo_count,
                referee_pro_days: user.referee_pro_days,
              })
            "
          ></p>
          <svg width="28" height="10" viewBox="0 0 28 10" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_46996_100455)">
              <path
                d="M26.1057 1.44721L10.3777 9.31118C8.82586 10.0871 7.00006 8.95866 7.00006 7.22369C7.00006 3.78644 4.21362 1 0.776367 1V0H28.0001V1C27.3425 1 26.6939 1.15311 26.1057 1.44721Z"
                fill="currentColor"
              />
              <path
                d="M25.8821 1L10.1541 8.86397C8.93476 9.47365 7.50006 8.58697 7.50006 7.22369C7.50006 3.5103 4.48976 0.5 0.776367 0.5H27.5001V0.526466C26.9381 0.58613 26.39 0.746056 25.8821 1Z"
                stroke="black"
                stroke-opacity="0.05"
              />
              <path
                d="M2.49957 0C1.99957 0 27.0627 0 26.7811 0C26.4996 0 24.7476 1 24.7476 1H4.44488C4.44488 1 2.99957 0 2.49957 0Z"
                fill="currentColor"
              />
            </g>
            <defs>
              <clipPath id="clip0_46996_100455">
                <rect width="28" height="10" fill="white" />
              </clipPath>
            </defs>
          </svg>

          <div class="register__container__form__intro__user">{{ user.name }}</div>
        </div>

        <div class="register__container__form__right">
          <input
            type="text"
            class="register__container__form__input"
            name="email"
            :placeholder="$t('register.form.email')"
            v-model="email"
          />
          <div class="flex justify-between items-center">
            <input
              type="text"
              name="verify_code"
              v-model="verify_code"
              :placeholder="$t('register.form.verify_code')"
              class="register__container__form__input code"
            />
            <div
              @click="getVerifryCode"
              v-baidu-event-tracking="{ feature: code && user ? '邀请页操作' : '注册页操作', action: '获取验证码' }"
              style="width: 110px"
              class="register__container__form__input sendCode"
            >
              {{ isSend ? $t('register.form.sending_verify_code') : $t('register.form.send_verify_code') }}
            </div>
          </div>
          <input
            type="text"
            class="register__container__form__input"
            name="nickname"
            v-model="nickname"
            :placeholder="$t('register.form.nickname')"
          />
          <input
            type="password"
            class="register__container__form__input"
            name="password"
            v-model="password"
            :placeholder="$t('register.form.password')"
          />
          <input
            type="password"
            class="register__container__form__input"
            name="password2"
            v-model="password2"
            :placeholder="$t('register.form.password_again')"
          />
          <input type="hidden" name="wechat_open_id" />
          <input type="hidden" name="code" />

          <div
            class="register__container__form__submit"
            v-baidu-event-tracking="{ feature: code && user ? '邀请页操作' : '注册页操作', action: '注册按钮' }"
            @click="doRegister"
          >
            {{ $t('register.form.submit') }}
          </div>
          <div class="flex items-center justify-start register__container__form__terms">
            <input type="checkbox" v-model="agree" name="terms" />
            <div>
              {{ $t('register.form.privacy.append_text') }}
              <a href="https://help.flomoapp.com/legal/" target="_blank">{{ $t('register.form.privacy.text1') }}</a>
              {{ $t('register.form.privacy.and_text') }}
              <a href="https://help.flomoapp.com/privacy.html" target="_blank">{{
                $t('register.form.privacy.text2')
              }}</a>
            </div>
          </div>
          <div class="register__container__form__action flex items-center justify-center">
            <el-link
              :underline="false"
              v-baidu-event-tracking="{ feature: code && user ? '邀请页操作' : '注册页操作', action: '立即登录' }"
              @click="redirectToLogin"
              >{{ $t('register.form.login') }}</el-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Register',
  data() {
    return {
      email: '',
      nickname: '',
      password: '',
      password2: '',
      verify_code: '',
      code: '',
      agree: false,
      user: null,
      isSend: false,
      isElectron: this.$store.getters.isElectron,
    }
  },
  computed: {
    isMobile() {
      return this.$isMobile() || document.body.clientWidth < 640
    },
    wechatAccount() {
      return this.$store.getters['wxLogin/wechatAccount']
    },
    appleAccount() {
      return this.$store.getters['appleLogin/account']
    },
  },
  methods: {
    doRegister() {
      if (this.password !== this.password2) {
        this.$message.error(this.$t('register.form.warning.password_not_same'))
        return
      }
      if (!this.email) {
        this.$message.error(this.$t('register.form.warning.email_needed'))
        return
      }
      if (!this.nickname) {
        this.$message.error(this.$t('register.form.warning.nickname_needed'))
        return
      }
      if (!this.password) {
        this.$message.error(this.$t('register.form.warning.password_needed'))
        return
      }
      if (!this.verify_code) {
        this.$message.error(this.$t('register.form.warning.verify_code_needed'))
        return
      }

      if (!this.agree) {
        this.$message.error(this.$t('register.form.warning.terms_need_agree'))
        return
      }

      const { wechatAccount, appleAccount } = this

      const wechat_union_id = wechatAccount?.union_id ?? ''
      const wechat_oa_open_id = wechatAccount?.oa_open_id ?? ''
      const apple_sub = appleAccount?.sub ?? ''

      this.$api.call(
        'POST',
        '/user/register',
        {
          email: this.email,
          verify_code: this.verify_code,
          password: this.password,
          name: this.nickname,
          code: this.code ? this.code : '',
          language: window.navigator.language.toLowerCase(),
          wechat_union_id,
          wechat_oa_open_id,
          apple_sub,
        },
        (response) => {
          const {
            data: { message, code, data },
          } = response
          if (code === 0) {
            this.$store.commit('setMe', data)
            if (data.access_token) {
              // 有 access_token 才算登录成功
              this.$router.replace({
                name: 'mine',
              })
            } else {
              this.$message.error(message)
            }
          }
        },
      )
    },
    getVerifryCode() {
      if (!this.email) {
        return this.$message.error(this.$t('login.message.fill_email'))
      }
      this.isSend = true
      this.$api.call(
        'POST',
        '/user/send_verify_code/',
        {
          email: this.email,
          language: window.navigator.language.toLowerCase(),
        },
        (response) => {
          const {
            data: { message, code },
          } = response
          if (code == 0) {
            this.$message.success(message)
          }
        },
      )
    },
    getUserRefererInfo() {
      this.$api.call(
        'GET',
        '/user/referer_info/',
        {
          code: this.code,
        },
        (response) => {
          const {
            data: { message, code, data },
          } = response
          if (code == 0) {
            this.user = data
          }
        },
      )
    },
    // 截取地址?后的字符串
    getCode() {
      return window.location.href.match(/\?([^&]*)/) !== null ? window.location.href.match(/\?([^&]*)/)[1] : ''
    },

    redirectToForgetpassword() {
      this.$router.push({
        name: 'forget',
      })
    },
    redirectToLogin() {
      this.$router.push({
        name: 'login',
      })
    },
    redirectToHome() {
      window.location.replace('/')
    },
  },
  created() {
    if (this.getCode()) {
      this.code = this.getCode()
      this.getUserRefererInfo()
    }
  },
}
</script>
<style lang="scss" scoped>
.register {
  &__container {
    width: 650px;
    margin: 100px auto;
    &__header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 45px;
      &__icon {
        &--logo {
          width: 31.6px !important;
          height: 24px !important;
          color: var(--bgGreen) !important;
        }
        &--text {
          width: 79.5px !important;
          height: 24px !important;
          margin-left: 5px;
          color: var(--logoColor) !important;
        }
      }
      &__text {
        font-size: 20px;
        font-weight: 600;
        color: var(--textBlack);
      }
    }
    &__form {
      justify-content: space-between;
      &__intro {
        position: relative;
        line-height: 25.2px;
        font-size: 14px;
        margin-bottom: 30px;
        svg {
          bottom: 9px;
          left: 20px;
          position: relative;
          color: var(--mark-bg);

          // path {
          //  stroke: rgba(0, 0, 0, 0.05);
          //}
        }

        &__text {
          padding: 15px;
          border-radius: 6px;
          background: var(--mark-bg);
          position: relative;
          color: var(--payFeedbackColor);
          border: 1px solid rgba(0, 0, 0, 0.05);
          //&:after {
          //  content: '';
          //  position: absolute;
          //  bottom: 0;
          //  left: 20%;
          //  border: 14px solid transparent;
          //  border-top-color: var(--mark-bg);
          //  border-bottom: 0;
          //  margin: 0 0 -14px -14px;
          //  border-left: 0;
          //}
        }
        &__user {
          font-size: 16px;
          font-weight: 700;
          margin-top: -14px;
          padding-left: 10px;
          color: var(--payFeedbackColor);
        }
      }
      &__input {
        border: 1px solid var(--loginBtnBorder);
        box-sizing: border-box;
        border-radius: 6px;
        padding: 19px 20px;
        width: 100%;
        margin-bottom: 15px;
        background: var(--loginInputBg);
        color: var(--memoContentColor);
        &::placeholder {
          color: #9d9d9d;
        }
      }
      .code {
        width: 280px;
      }
      .sendCode {
        cursor: pointer;
        font-size: 12px;
        border: 1px solid var(--bgGreen);
        color: var(--bgGreen);
        &:hover {
          background: var(--hoverBg);
        }
      }
      &__submit {
        background: var(--bgGreen);
        border: 1px solid var(--loginBtnBorder);
        box-sizing: border-box;
        border-radius: 6px;
        padding: 16px 20px;
        color: var(--memberPlanColor);
        cursor: pointer;
        width: 100%;
        margin-bottom: 15px;
        text-align: center;
        &:hover {
          background: var(--yearPlanHoverBg);
        }
      }
      &__terms {
        margin-bottom: 15px;
        input {
          margin-right: 10px;
        }
        div {
          color: #9d9d9d;
          font-size: 14px;
          font-weight: 400;
          a {
            color: #9d9d9d;
          }
        }
      }
      &__action {
        margin-top: 30px;
      }
    }
  }
}
</style>

<style lang="scss">
.register {
  &__container {
    &__form {
      .el-link.el-link--default {
        color: var(--tagColor);
        font-weight: unset;
      }
    }
  }
}
</style>
<style scoped lang="scss">
@media screen and (max-width: 650px) {
  .register {
    &__container {
      width: 350px;
      &__form {
        .code {
          width: 230px;
        }
        &__right {
          width: 350px;
        }
      }
    }
  }
}

@media screen and (min-width: 650px) {
  .register {
    &__container {
      &__form {
        display: flex;
        &__right {
          width: 400px;
        }
      }
    }
  }
}
</style>
